
import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import timeutils from 'utils/wt-time-utils'
import otherServiceData from '../datas/other-service'
export default{
  // 获取意见反馈列表
  getFeedbackList (ctx, data) {
    return fetch.getFeedbackList(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
      })
      return result
    })
  },
  // 获取意见反馈详情
  getFeedbackDetail (ctx, data) {
    return fetch.getFeedbackDetail(data).then(res => {
      res.data.createdDate = timeutils.format(res.data.createdDate, 'default')
      return res
    })
  },
  // 搜索意见反馈列表
  getFeedbackSearch (ctx, data) {
    return fetch.getFeedbackSearch(data).then(res => {
      let result = getTotalNumber(res)
      result.data.forEach(item => {
        item.createdDate = timeutils.format(item.createdDate, 'default')
      })
      return result
    })
  },
  // 获取售后服务列表
  afterSalesPolicies (ctx, data) {
    return fetch.afterSalesPolicies(data).then(res => {
      let result = getTotalNumber(res)
      result.data = otherServiceData.policyManage(result.data, '售后政策')
      return result
    })
  },
  // 获取售后服务详情
  afterSalesPolicyDetail (ctx, id) {
    return fetch.afterSalesPolicyDetail(id).then(res => {
      res.data = otherServiceData.policyDetail(res.data)
      return res.data
    })
  },
  // 新建售后政策
  creatAfterSalesPolicies (ctx, data) {
    return fetch.creatAfterSalesPolicies(data).then(res => {
      return res.data
    })
  },
  // 编辑售后政策
  editAfterSalesPolicy (ctx, data) {
    return fetch.editAfterSalesPolicy(data).then(res => {
      return res.data
    })
  },
  // 删除售后政策
  afterSalesDelete (ctx, id) {
    return fetch.afterSalesDelete(id).then(res => {
      return res.data
    })
  },
  // 获取运费规则列表
  getCarriagePolicies (ctx, data) {
    return fetch.getCarriagePolicies(data).then(res => {
      let result = getTotalNumber(res)
      result.data = otherServiceData.policyManage(result.data, '运费政策')
      return result
    })
  },
  // 获取运费规则详情
  carriagePoliciesDetail (ctx, id) {
    return fetch.carriagePoliciesDetail(id).then(res => {
      res.data = otherServiceData.policyDetail(res.data)
      return res.data
    })
  },
  // 新建运费规则
  creatCarriagePolicies (ctx, data) {
    return fetch.creatCarriagePolicies(data).then(res => {
      return res.data
    })
  },
  // 删除运费规则
  carriagePolicyDelete (ctx, id) {
    return fetch.carriagePolicyDelete(id).then(res => {
      return res.data
    })
  },
  // 获取隐私条款列表
  getPrivacyPolicies (ctx, data) {
    return fetch.getPrivacyPolicies(data).then(res => {
      let result = getTotalNumber(res)
      result.data = otherServiceData.policyManage(result.data, '隐私条款')
      return result
    })
  },

  // 新建隐私条款
  createPrivacyPolicies (ctx, data) {
    return fetch.createPrivacyPolicies(data).then(res => {
      return res.data
    })
  },
  // 获取隐私条款详情
  privacyPolicyDetail (ctx, id) {
    return fetch.privacyPolicyDetail(id).then(res => {
      res.data = otherServiceData.policyDetail(res.data)
      return res.data
    })
  },
  privacyPolicyDelete (ctx, id) {
    return fetch.privacyPolicyDelete(id).then(res => {
      return res.data
    })
  },
  // 获取积分商城运费规则列表
  getIntegralaCarriagePolicies (ctx, data) {
    return fetch.getIntegralaCarriagePolicies(data).then(res => {
      let result = getTotalNumber(res)
      result.data = otherServiceData.policyManage(result.data, '运费政策')
      return result
    })
  },
  // 获取积分商城隐私政策列表
  getIntegralPrivacyPolicies (ctx, data) {
    return fetch.getIntegralPrivacyPolicies(data).then(res => {
      let result = getTotalNumber(res)
      result.data = otherServiceData.policyManage(result.data, '隐私条款')
      return result
    })
  },
  // 获取积分商品售后政策
  getIntegralAfterSalesPolicies (ctx, data) {
    return fetch.getIntegralAfterSalesPolicies(data).then(res => {
      let result = getTotalNumber(res)
      result.data = otherServiceData.policyManage(result.data, '售后政策')
      return result
    })
  },
  // 积分商品售后政策详情
  integralAfterSalesPolicieDetail (ctx, id) {
    return fetch.integralAfterSalesPolicieDetail(id).then(res => {
      res.data = otherServiceData.policyDetail(res.data)
      return res.data
    })
  },
  // 创建积分商品售后政策
  createIntegralAfterSalesPolicies (ctx, data) {
    return fetch.createIntegralAfterSalesPolicies(data).then(res => {
      return res.data
    })
  },
  // 编辑积分商品售后政策
  editIntegralAfterSalesPolicie (ctx, data) {
    return fetch.editIntegralAfterSalesPolicie(data).then(res => {
      return res.data
    })
  },
  // 删除积分商品售后政策
  deleteIntegralAfterSalesPolicie (ctx, id) {
    return fetch.deleteIntegralAfterSalesPolicie(id).then(res => {
      return res.data
    })
  },
  // 获取积分商品运费规则详情
  getCarriagePoliciesDetail (ctx, id) {
    return fetch.getCarriagePoliciesDetail(id).then(res => {
      return res.data
    })
  },
  // 获取积分商品隐私政策
  createIntegralCarriagePolicies (ctx, data) {
    return fetch.createIntegralCarriagePolicies(data).then(res => {
      return res.data
    })
  },
  // 获取积分商品隐私条款
  getPrivacyPoliciesDetail (ctx, id) {
    return fetch.getPrivacyPoliciesDetail(id).then(res => {
      return res.data
    })
  },
  // 创建积分商品隐私政策
  createIntegralPrivacyPolicies (ctx, data) {
    return fetch.createIntegralPrivacyPolicies(data).then(res => {
      return res.data
    })
  },
  deleteIntegralCarriagePolicie (ctx, id) {
    return fetch.deleteIntegralCarriagePolicie(id).then(res => {
      return res.data
    })
  },
  deletePrivacyPolicies (ctx, id) {
    return fetch.deletePrivacyPolicies(id).then(res => {
      return res.data
    })
  }
}
